import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

const prepareCharacteristicToClient = (res: IPropertyDetailsResponse) => {
  return {
    bedrooms_property: checkIfEmpty(res?.bedrooms),
    bathrooms_property: checkIfEmpty(res?.bathrooms),
    half_bathrooms_property: checkIfEmpty(res?.half_bathrooms),
    parking_spots_property: checkIfEmpty(res?.parking_spots),
    total_floor_property: checkIfEmpty(res?.floors_total),
    level_floor_property: checkIfEmpty(res?.floor_level),
    pumps_property: checkIfEmpty(res?.pumps)
  };
};

export default prepareCharacteristicToClient;

const checkIfEmpty = (value: number) => {
  if (value == 0) {
    return [0];
  } else if (value) {
    return [value];
  } else {
    return [];
  }
};
